import { Hero } from "@/components/hero";
import { Header } from "@/components/header";
import { Models } from "@/components/models";
import { Footer } from "@/components/footer";
import { StatsBanner } from "@/components/stats-banner";
import FAQSection from "@/components/faq";
import { useEffect } from "react";
import { useLocation } from "wouter";
import { Partners } from "@/components/partners";
import { BeforeAfterOley } from "@/components/before-after-oley";
import { BackToTop } from "@/components/back-to-top";
import CaseStudies from '@/components/case-studies';
import { WhyChooseUs } from "@/components/why-choose-us";
import { BenefitsCloud } from "@/components/benefits-cloud";

interface HomePageProps {
  isLoggedIn?: boolean;
}

export default function HomePage({ isLoggedIn = false }: HomePageProps) {
  const [location] = useLocation();
  
  // Handle hash navigation
  useEffect(() => {
    // Smooth scroll to section when hash changes
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
    
    // Initial check
    handleHashChange();
    
    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [location]);

  const handleDashboardClick = () => {
    window.location.href = import.meta.env.VITE_DASHBOARD_URL || 'https://dashboard.oleyes.com';
  };

  return (
    <div className="min-h-screen">
      <Header 
        isLoggedIn={isLoggedIn} 
        onDashboardClick={handleDashboardClick}
      />
      
      <Hero />
      <BenefitsCloud />
      <WhyChooseUs />
      <Partners />
      <Models />
      <CaseStudies />
      <BeforeAfterOley />

      <StatsBanner />
      
      <FAQSection  />
      
      
      
      <Footer />
      <BackToTop />
    </div>
  );
}
